import { Empty, Flex } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { getStudioList } from '../../api/aops.vacation.api'
import { getPastWatchdogListByStudio } from '../../api/watchdog.api'
import AopsHeader from '../../components/apos/AopsHeader'
import SectionHeader from '../../components/apos/SectionHeader'
import { menuSelectedStudio } from '../../store/aops'
import {
  scheduleBoardRefetchTrigger,
  standaloneScheduleViewUserId,
  trackerBoardRefetchTrigger,
} from '../../store/standaloneSchedule'
import StandAloneAdminDashBoard from './components/StandAloneAdminDashBoard'
import StandaloneWatchdogPopup from './components/StandaloneWatchdogPopup'
import './ScheduleVisionboard.scss'
import './StandaloneSchedulePage.scss'

const ScheduleVisionBoardPage = () => {
  const today = dayjs()

  // 월요일 기준으로 주 시작일 계산
  const monday = today.startOf('week').add(1, 'day')
  const friday = monday.add(4, 'day')

  const result = `${monday.format('MM/DD')} - ${friday.format('MM/DD')} · 5일간`
  const { studio, team, id } = useParams()
  const setViewUserId = useSetRecoilState(standaloneScheduleViewUserId)
  const setTrackerBoardRefetch = useSetRecoilState(trackerBoardRefetchTrigger)
  const refetchTrigger = useRecoilValue(trackerBoardRefetchTrigger)
  const setScheduleBoardRefetch = useSetRecoilState(scheduleBoardRefetchTrigger)
  const [selectedStudio] = useRecoilState(menuSelectedStudio)
  useEffect(() => {
    setViewUserId(id ?? null)
    return () => setViewUserId(null)
  }, [id, setViewUserId])
  const [isWatchdogPopupOpen, setIsWatchdogPopupOpen] = useState(false)
  const [selectedWatchdogId, setSelectedWatchdogId] = useState(null)
  const [isWatchdogTaskPopupOpen, setIsWatchdogTaskPopupOpen] = useState(false)
  const [selectedTaskId, setSelectedTaskId] = useState(null)
  const [selectedTask, setSelectedTask] = useState(null)
  const [goalList, setGoalList] = useState([])
  const [pastWatchdogList, setPastWatchdogList] = useState([])
  const [studioGroupId, setStudioGroupId] = useState(null)

  // 트래커 보드 & 스케쥴 보드 refetch (루틴/Fast 업무 생성 시)
  const handleRefetchTrackerBoard = () => {
    setTrackerBoardRefetch((prev) => prev + 1)
    setScheduleBoardRefetch((prev) => prev + 1)
  }

  useEffect(() => {
    const fetchStudioGroupId = async () => {
      const res = await getStudioList(selectedStudio)
      const id = res?.find((item) => item.name === selectedStudio)?.id
      setStudioGroupId(id)
    }
    if (selectedStudio) {
      fetchStudioGroupId()
    }
  }, [selectedStudio])
  // 과거 워치 도그 리스트 조회
  useEffect(() => {
    if (studioGroupId && refetchTrigger) {
      const fetchPastWatchdogList = async () => {
        try {
          const res = await getPastWatchdogListByStudio(studioGroupId)
          setPastWatchdogList(res || [])
          console.log('pastWatchdogList::', res)
        } catch (error) {
          console.log('error::', error)
          setPastWatchdogList([])
        }
      }
      fetchPastWatchdogList()
    }
  }, [studioGroupId, refetchTrigger])

  // 상세 보기 열기
  const openWatchdogPopup = (watchdogId) => {
    setSelectedWatchdogId(watchdogId)
    setIsWatchdogPopupOpen(true)
  }

  return (
    <>
      <div className="standalone-schedule-page">
        <AopsHeader active="schedule-dashboard" />
        <div style={{ padding: '16px 32px' }}>
          <SectionHeader
            title="Ops. 보드"
            subtitle="팀에서 발생한 이슈를 한눈에 확인할 수 있어요"
            buttonText="Weekly Goal 생성"
            buttonColor1="#191A1C"
            icon1={
              <img
                src="/assets/icon/aops/black-circle-star-icon.svg"
                alt="watchdog"
                style={{ width: '20px', height: '20px', marginRight: '6px' }}
              />
            }
            onButtonClick={() => {
              setSelectedWatchdogId(null)
              setIsWatchdogPopupOpen(true)
            }}
          />
          <StandAloneAdminDashBoard
            onWatchdogClick={(watchdog) => {
              setSelectedWatchdogId(watchdog.id)
              setIsWatchdogPopupOpen(true)
            }}
            setGoalList={setGoalList}
          />

          {/* 여기서부터 워치도 비전 보드 */}
          <div className="schedule-vision-board">
            <div className="vision-board__main">
              {/* Weekly Goal */}

              <section className="vision-board__weekly">
                <div className="vision-board__header">
                  <div className="vision-board__header-left">
                    <h2 className="vision-board__title">Weekly Goal</h2>
                    <span className="vision-board__subtitle">{result}</span>
                  </div>
                  <span className="vision-board__header-meta">
                    {monday.format('MM/DD')} - {friday.format('MM/DD')} · 5일간
                  </span>
                </div>

                <div
                  className="vision-board__goals"
                  style={{
                    gridTemplateColumns:
                      goalList.length > 0 ? 'repeat(2, 1fr)' : '1fr',
                  }}
                >
                  {goalList.length > 0 &&
                    goalList.map((goal, index) => (
                      <div
                        key={goal.id + 'goal-card'}
                        className="vision-board__goal-card"
                        onClick={() => openWatchdogPopup(goal.id)}
                      >
                        <div className="vision-board__goal-icon">
                          <div>{goal.icon}</div>
                        </div>
                        <span className="vision-board__goal-label">
                          Goal {index + 1}
                        </span>
                        <p className="vision-board__goal-desc">{goal.title}</p>
                        {goal?.checkLists?.length > 0 && (
                          <>
                            <span className="vision-board__goal-must">
                              Must - Do
                            </span>
                            <ul className="vision-board__must-list">
                              {goal?.checkLists?.map((checkList) => (
                                <li className="vision-board__must-item">
                                  {checkList.title}
                                </li>
                              ))}
                            </ul>
                          </>
                        )}
                      </div>
                    ))}
                  {goalList.length === 0 && (
                    <Flex
                      align="center"
                      justify="center"
                      style={{ width: '100%', height: '100%' }}
                    >
                      <Empty description="Weekly Goal이 없습니다" />
                    </Flex>
                  )}
                </div>
              </section>
              {/* 지난 Goal */}
              <section className="vision-board__past">
                <div
                  className="vision-board__header"
                  style={{ background: '#fff', borderColor: '#fff' }}
                >
                  <div className="vision-board__header-left">
                    <h2 className="vision-board__title">지난 Goal</h2>
                  </div>
                  <span className="vision-board__header-meta">최신순</span>
                </div>
                <div className="vision-board__past-list">
                  {pastWatchdogList?.length > 0 &&
                    pastWatchdogList?.map((past) => (
                      <div
                        key={past.id + 'past-watchdog'}
                        className="vision-board__past-item"
                        onClick={() => openWatchdogPopup(past.id)}
                      >
                        <div className="vision-board__past-icon">
                          <div>{past.icon}</div>
                        </div>
                        <p className="vision-board__past-desc">{past.title}</p>
                      </div>
                    ))}
                  {pastWatchdogList?.length === 0 && (
                    <Flex
                      align="center"
                      justify="center"
                      style={{ width: '100%', height: '100%' }}
                    >
                      <Empty
                        description=" 지난 Goal이 없습니다."
                        style={{ marginTop: '16px' }}
                      />
                    </Flex>
                  )}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* 모달 */}

      <StandaloneWatchdogPopup
        open={isWatchdogPopupOpen}
        onClose={(opts) => {
          setIsWatchdogPopupOpen(false)
          setSelectedWatchdogId(null)
          if (opts?.deleted) setTimeout(() => handleRefetchTrackerBoard(), 0)
        }}
        watchdogId={selectedWatchdogId}
        onSuccess={handleRefetchTrackerBoard}
        onOpenTaskPopup={() => {
          setSelectedTaskId(null)
          setSelectedTask(null)
          setIsWatchdogTaskPopupOpen(true)
        }}
        onOpenTaskEditPopup={(task) => {
          setSelectedTaskId(task.id)
          setSelectedTask(task)
          setIsWatchdogTaskPopupOpen(true)
        }}
      />
    </>
  )
}

export default ScheduleVisionBoardPage
